import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ForgotService } from '../shared/Forgot.Service';
import { AppInsightsService } from '../shared/AppInsights.Service';

@Component({
  selector: 'app-identity-mgt-client',
  templateUrl: './identity-mgt-client.component.html',
  styleUrls: ['./identity-mgt-client.component.scss']
})
export class IdentityMgtClientComponent implements OnInit {
  public type = '';
  categories: {};
  selection = { name: '' };

  constructor(private router: Router, private forgotService: ForgotService, private appInsightsService: AppInsightsService) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.appInsightsService.logEvent("Forgot UI Page - Client");
    this.forgotService.getType().subscribe(res => {
      this.type = res;
    });
  }

}
